module.exports = __webpack_public_path__ + "assets/grid-layout-active.2c7a0ae7.svg";